/*
 * MitoJenix Research Co. - Phase 1 compliance behaviour (cart agreement gate).
 *
 * The age gate ships inline in snippets/mjx-age-gate.liquid so that it can run
 * before first paint; this file governs only the cart / cart drawer agreement
 * checkbox. It is deliberately dependency-free and re-entrant, because Horizon
 * morphs the cart markup in place after every quantity or discount change.
 */
(function () {
  'use strict';

  if (window.mjxComplianceLoaded) return;
  window.mjxComplianceLoaded = true;

  var CTA_SELECTOR = '.cart__ctas';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], .cart__checkout-button, #checkout';

  function complianceFor(node) {
    if (!node || !node.closest) return null;
    var ctas = node.closest(CTA_SELECTOR);
    if (!ctas) return null;
    return ctas.querySelector('[data-mjx-compliance]');
  }

  function isAgreed(container) {
    var box = container.querySelector('[data-mjx-compliance-checkbox]');
    return !!(box && box.checked);
  }

  function showError(container) {
    var message = container.querySelector('[data-mjx-compliance-error]');
    if (message) message.hidden = false;
    container.classList.add('mjx-cart-compliance--invalid');
  }

  function clearError(container) {
    var message = container.querySelector('[data-mjx-compliance-error]');
    if (message) message.hidden = true;
    container.classList.remove('mjx-cart-compliance--invalid');
  }

  function sync(container) {
    var ctas = container.closest(CTA_SELECTOR);
    if (!ctas) return;
    var agreed = isAgreed(container);
    ctas.classList.toggle('mjx-locked', !agreed);
    var buttons = ctas.querySelectorAll(CHECKOUT_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-disabled', agreed ? 'false' : 'true');
    }
    if (agreed) clearError(container);
  }

  function syncAll() {
    var containers = document.querySelectorAll('[data-mjx-compliance]');
    for (var i = 0; i < containers.length; i++) sync(containers[i]);
  }

  /* Toggling the checkbox updates the checkout button state. */
  document.addEventListener('change', function (event) {
    var box = event.target && event.target.closest
      ? event.target.closest('[data-mjx-compliance-checkbox]')
      : null;
    if (!box) return;
    var container = box.closest('[data-mjx-compliance]');
    if (container) sync(container);
  });

  /* Policy links inside the agreement label must not toggle the checkbox. */
  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest
      ? event.target.closest('.mjx-cart-compliance__text a')
      : null;
    if (link) event.stopPropagation();
  });

  /* Block the checkout button while the agreement is unchecked. */
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest(CHECKOUT_SELECTOR)
      : null;
    if (!button) return;
    var container = complianceFor(button);
    if (!container || isAgreed(container)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    showError(container);
    var box = container.querySelector('[data-mjx-compliance-checkbox]');
    if (box) box.focus();
  }, true);

  /* Belt and braces: block the cart form submit that the button drives. */
  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (!submitter || !submitter.matches || !submitter.matches(CHECKOUT_SELECTOR)) return;
    var container = complianceFor(submitter);
    if (!container || isAgreed(container)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    showError(container);
  }, true);

  /* Re-apply state after Horizon re-renders the cart or opens the drawer. */
  var frame = null;
  var observer = new MutationObserver(function () {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      syncAll();
    });
  });

  function init() {
    syncAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
